import instance from "./instance";

import authModule from "./modules/auth";
import placeModule from "./modules/place";
import edu_specModule from "./modules/edu_spec";
import mapModule from "./modules/map";
import userModule from "./modules/user";
import documentModule from "./modules/document";
import planModule from "./modules/plan";
import othersModule from "./modules/others";
import facultySpecModule from "./modules/facultySpec";
import placeSchoolModule from "./modules/placeSchool";

// import disciplineModel from './modules/discipline'

export default {
  instance,
  auth: authModule(instance),
  place: placeModule(instance),
  edu_spec: edu_specModule(instance),
  map: mapModule(instance),
  user: userModule(instance),
  documents: documentModule(instance),
  plan: planModule(instance),
  others: othersModule(instance),
  facultySpec: facultySpecModule(instance),
  placeSchool: placeSchoolModule(instance),
  // discipline: disciplineModel(instance)
};
